/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyScopeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyScopeQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyScopeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyScopeQueryOperator>): PolicyScopeQueryOperator {
        let obj = Object.assign(new PolicyScopeQueryOperator(), model);
        PolicyScopeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyScopeQueryOperator>): PolicyScopeQueryOperator {
        if (!model) return null;
        return PolicyScopeQueryOperator.newInstance(<PolicyScopeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyScopeQueryOperator) {
        if (!obj) return;

        models.PolicyScopeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyScopeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyScopeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy scopes to include
     */
    scopes: Array<models.PolicyV2Scope>;

}
